import { render, staticRenderFns } from "./MapboxComponent.vue?vue&type=template&id=610ac614&scoped=true"
import script from "./MapboxComponent.vue?vue&type=script&lang=js"
export * from "./MapboxComponent.vue?vue&type=script&lang=js"
import style0 from "./MapboxComponent.vue?vue&type=style&index=0&id=610ac614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610ac614",
  null
  
)

export default component.exports